// 중앙집중식 설정 관리
const getConfig = () => {
  // 개발 환경 체크 제거 - HTTPS 지원을 위해

  // 1. 런타임 설정 우선 (runtime-config.js)
  if (window.RUNTIME_CONFIG) {
    return {
      API_URL: window.RUNTIME_CONFIG.API_URL,
      SOCKET_URL: window.RUNTIME_CONFIG.SOCKET_URL,
      UPLOAD_URL: window.RUNTIME_CONFIG.UPLOAD_URL || window.RUNTIME_CONFIG.API_URL.replace('/api', '').replace(':5101', ':5100')
    };
  }

  // 2. 빌드 시점 환경 변수
  if (process.env.REACT_APP_API_URL) {
    return {
      API_URL: process.env.REACT_APP_API_URL,
      SOCKET_URL: process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL,
      UPLOAD_URL: process.env.REACT_APP_UPLOAD_URL || process.env.REACT_APP_API_URL.replace(':5101', ':5100')
    };
  }

  // 3. 현재 호스트 기반 동적 결정 (localhost 하드코딩 제거)
  const hostname = window.location.hostname;
  const port = window.location.port;
  const protocol = window.location.protocol;

  // 환경변수가 없을 경우 .env 설정 기반 기본 포트 사용
  // 기본값: tosino 개발 환경의 user-api 포트 4101, admin-api 포트 4100
  const API_PORT = process.env.REACT_APP_API_PORT || '4101';
  const ADMIN_PORT = process.env.REACT_APP_ADMIN_PORT || '4100';

  // 로컬 개발 환경 (localhost나 127.0.0.1에서만 HTTP 사용)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return {
      API_URL: `http://${hostname}:${API_PORT}/api`,
      SOCKET_URL: `http://${hostname}:${API_PORT}`,
      UPLOAD_URL: `http://${hostname}:${ADMIN_PORT}`
    };
  }

  // HTTPS 환경에서는 nginx 프록시를 통해 /api 경로 사용
  if (protocol === 'https:') {
    return {
      API_URL: '/api',
      SOCKET_URL: window.location.origin,  // WebSocket을 위한 명시적 origin 사용
      UPLOAD_URL: ''   // 같은 origin 사용
    };
  }

  // HTTP 환경 (개발 서버)
  if (process.env.NODE_ENV === 'development') {
    return {
      API_URL: `http://${hostname}:${API_PORT}/api`,
      SOCKET_URL: `http://${hostname}:${API_PORT}`,
      UPLOAD_URL: `http://${hostname}:${ADMIN_PORT}`
    };
  }

  // 기본값 (HTTPS 프로덕션)
  return {
    API_URL: '/api',
    SOCKET_URL: window.location.origin,
    UPLOAD_URL: ''
  };
};

const config = getConfig();

// 개발 환경에서 설정 확인
console.log('[Config] Window RUNTIME_CONFIG:', window.RUNTIME_CONFIG);
console.log('[Config] Loaded configuration:', config);

export default config;
